<template>
  <button
    :class="[ 'reset', 'm-tooltip', { 'm-tooltip--disabled': isDisabled }]"
    :tabindex="isDisabled ? -1 : 0"
    x-placement="right"
    v-tooltip="{
      content: html,
      html: true,
      triggers: ['hover', 'click']
    }"
    :aria-label="text"
  >
    <i class="icon-help-o" />
  </button>
</template>
<script>
import { VTooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'

export default {
  name: 'Tooltip',
  directives: {
    tooltip: VTooltip
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    html () {
      return `<div class="m-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner">${this.text}</div></div>`
    }
  }
}
</script>

<style lang="less">
@import (reference) "./../../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/modules/m-tooltip.less";

.m-tooltip {
    .tooltip-inner {
        background-color: transparent;
    }
    .tooltip-arrow {
        border: none
    }

    &--disabled {
      filter: grayscale() opacity(40%);
      pointer-events: none;
    }

    i {
      display: block;
    }
}
</style>
